import { URL_APP_TYPE } from 'consts';
import type { ValueOf } from 'types';

import type { CxLoginApiResponse } from '../../api/types';
import type { MetaState } from '../../modules/meta/constants';

export const validateAppType = (appType: ValueOf<typeof URL_APP_TYPE> | null): appType is MetaState['appType'] => {
    return appType !== null && Object.values(URL_APP_TYPE).includes(appType);
};

export const getAppTypeFromResponseHeaders = (
    response: CxLoginApiResponse,
    urlAppType: MetaState['appType'],
): MetaState['appType'] => {
    const urlApptypeHeader = response.response.headers.get('apptype') as ValueOf<typeof URL_APP_TYPE>;

    return validateAppType(urlApptypeHeader) ? urlApptypeHeader : urlAppType;
};
